export const APP_NAME = 'AlertAI';
export const APP_VERSION = '1.0.0';

// ================================================
// LEGACY CONSTANTS (SII-specific, kept for backward compatibility)
// ================================================
export const DOCUMENT_TYPES = {
  OFICIO: 'oficio',
  CIRCULAR: 'circular',
  RESOLUCION: 'resolucion',
} as const;

export const DOCUMENT_TYPE_LABELS = {
  oficio: 'Oficio',
  circular: 'Circular',
  resolucion: 'Resolución',
} as const;

export const MATERIAS = {
  RENTA: 'renta',
  IVA: 'iva',
  OTRAS: 'otras',
} as const;

export const MATERIA_LABELS = {
  renta: 'Renta',
  iva: 'IVA',
  otras: 'Otras',
} as const;

// ================================================
// NEW: Multi-Institution Support
// Import from institutions.ts for centralized config
// ================================================
export { INSTITUTIONS, getAllInstitutions, getInstitution, getInstitutionTypes } from './institutions';

export const ROLES = {
  ADMIN: 'admin',
  USER: 'user',
} as const;

export const ITEMS_PER_PAGE = 20;

export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATETIME_FORMAT = 'DD/MM/YYYY HH:mm';

export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  BIBLIOTECA: '/biblioteca',
  FAVORITOS: '/favoritos',
  PERFIL: '/perfil',
  ADMIN: '/admin',
  DOCUMENT_DETAIL: '/documento/:id',
} as const;
